import DeliveryList from './DeliveryList'

export default {
  list: DeliveryList,
}
